

const filesToAttachments = (files = []) => {
  const arr = Array.isArray(files) ? files : (files ? [files] : []);
  return arr.filter(Boolean).map((it) => {
    const f = it.file || it.blob || it;           // support {file}, {blob}, File
    const previewUrl = URL.createObjectURL(f);
    const mime = it.mime || f.type || "";
    const isImage = mime.startsWith("image/");
    return {
      id: `local-${Math.random().toString(36).slice(2)}`,
      type: isImage ? "image" : "file",
      name: f.name,
      mime,
      bytes: f.size,
      width: it.width || undefined,              
      height: it.height || undefined,
      previewUrl,                  
      sha256: it.sha256              
    };
  });
};

const buildAttachmentsPayload = (meta = [], targets = []) =>
  meta.map((m, i) => {
    const t = targets[i] || {};
    const f = m.file;

    const mime = (m.mime || f.type || "").toLowerCase();
    const kind = mime.startsWith("image/") ? "image" : "file";

    const storageKey = t.storageKey || t.storage_key; // tolerate either shape

    if (!storageKey) {
      throw new Error(`Missing storageKey from prepareImageUploads at index ${i}`);
    }

    return {
      storageKey,
      filename: f.name,
      mime,
      bytes: f.size,
      width: m.width ?? null,
      height: m.height ?? null,
      sha256: m.sha256 ?? null,
      kind,
    };
  });

export { filesToAttachments, buildAttachmentsPayload }
